export const REVENUECAT_PLUS_ENTITLEMENT_ID = 'tragenda_plus';
export const PLUS_MONTHLY_PRODUCT_ID = 'tragenda.plus.monthly.v1';
export const PLUS_ANNUAL_PRODUCT_ID = 'tragenda.plus.annual.v1';

export type PlusPeriod = 'monthly' | 'annual';

export interface PlusPriceOption {
  id: string;
  productId: string;
  period: PlusPeriod;
  priceLabel: string;
  detailLabel?: string;
}

export function isPaidTier(tier: string | undefined): tier is 'plus' | 'pro' | 'trip_pass' {
  return tier === 'plus' || tier === 'pro' || tier === 'trip_pass';
}

/**
 * RevenueCat Web Purchase Links identify an authenticated customer by adding
 * the app user id as the final path segment. We only accept RevenueCat's HTTPS
 * host so a bad build-time value cannot turn an upgrade button into an open
 * redirect.
 */
export function revenueCatWebPurchaseUrl(
  baseUrl: string,
  appUserId: string,
  packageId?: string,
): string | null {
  if (!baseUrl.trim() || !appUserId.trim()) return null;
  try {
    const url = new URL(baseUrl);
    if (url.protocol !== 'https:' || url.hostname !== 'pay.rev.cat') return null;
    const cleanPath = url.pathname.replace(/\/+$/, '');
    url.pathname = `${cleanPath}/${encodeURIComponent(appUserId)}`;
    if (packageId) url.searchParams.set('package_id', packageId);
    return url.toString();
  } catch {
    return null;
  }
}

export function plusPeriodForProduct(
  productId: string,
  monthlyProductId = PLUS_MONTHLY_PRODUCT_ID,
  annualProductId = PLUS_ANNUAL_PRODUCT_ID,
): PlusPeriod | null {
  if (productId === monthlyProductId) return 'monthly';
  if (productId === annualProductId) return 'annual';
  return null;
}

export function subscriptionManagementUrl(value?: string): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}
